import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ChartBarIcon, PlusIcon } from "@heroicons/react/24/outline";
import DashboardHeader from "../../../../../components/dashboard/dashboardHeader";

/**
 * HSE/KS Audits List - Internal audits list
 */
export const HseKsAuditsList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const headerActions = [
    {
      label: "Ny revisjon",
      icon: PlusIcon,
      path: "/dashboard/hse-ks/evaluation/audits/new",
      hidden: false,
      menu: false,
    },
  ];

  return (
    <DashboardHeader
      title="Internrevisjon"
      subtitle="Oversikt over internrevisjoner"
      actions={headerActions}
    >
      <div className="mx-auto mt-8 grid max-w-3xl grid-cols-1 gap-6 sm:px-6 lg:max-w-7xl lg:grid-flow-col-dense lg:grid-cols-3">
        <div className="space-y-6 lg:col-span-3 lg:col-start-1 sm:col-span-3">
          <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <p className="text-gray-500">Revisjonsliste kommer snart...</p>
            </div>
          </div>
        </div>
      </div>
    </DashboardHeader>
  );
};

